/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ProjectDataComponent } from '../../components/add-family-information/project-data/project-data-component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class ProjectDataDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = ProjectDataComponent;      
    sysquePopupConfig.width = 600;
    sysquePopupConfig.height = 570;
    sysquePopupConfig.componentTitle = 'Project Data';
  }
}
